import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { removeBlanksFromObj } from "@winshop-crm/lib";
import { EventsFilterState, TasksFilterState, UserFilter } from "@winshop-crm/types";

export const initialTasksFilter: TasksFilterState = {
  taskId: "",
  taskName: "",
  userIDs: "",
  taskStates: "",
  taskPriorities: "",
  companyIDs: "",
  projectIDs: "",
  createdByUserIDs: "",
  primarySolverUserIDs: "",
  secondarySolverUserIDs: "",
  controllingUserIDs: "",
  approvingUserIDs: "",
  bilingUserIDs: "",
  u1: "",
  u2: "",
  u3: "",
  u4: "",
  u5: "",

  requestedStartOfRealizationDateFrom: null,
  requestedStartOfRealizationDateTo: null,
  startOfRealizationDateFrom: null,
  startOfRealizationDateTo: null,
  requestedFinishDateFrom: null,
  requestedFinishDateTo: null,
  finishDateFrom: null,
  finishDateTo: null,
  handoverToCreatorDateFrom: null,
  handoverToCreatorDateTo: null,
};

export const initialEventsFilter: EventsFilterState = {
  eventId: "",
  eventName: "",
  userIDs: "",
  eventStates: "",
  companyIDs: "",
  projectIDs: "",
  createdByUserIDs: "",
  primarySolverUserIDs: "",
  secondarySolverUserIDs: "",
  controllingUserIDs: "",
  approvingUserIDs: "",
  bilingUserIDs: "",
  s1: "",
  s2: "",
  s3: "",
  s4: "",
  s5: "",

  creationDateFrom: null,
  creationDateTo: null,
  finishDateFrom: null,
  finishDateTo: null,
};

type FiltersState = {
  userFilters: UserFilter[] | null;
  tasksFilter: TasksFilterState;
  eventsFilter: EventsFilterState;
};

const initialState: FiltersState = {
  userFilters: null,
  tasksFilter: initialTasksFilter,
  eventsFilter: initialEventsFilter,
};

const filtersSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    setUserFilters: (state, action: PayloadAction<UserFilter[] | null>) => {
      state.userFilters = action.payload;
    },
    setTasksFilter: (state, action: PayloadAction<TasksFilterState>) => {
      state.tasksFilter = action.payload;
    },
    // NOTE: asymmetric with setTasksFilter by design — matches the pre-RTK reducer.
    setEventsFilter: (state, action: PayloadAction<EventsFilterState>) => {
      state.eventsFilter = removeBlanksFromObj(action.payload);
    },
  },
});

export const { setUserFilters, setTasksFilter, setEventsFilter } = filtersSlice.actions;
export default filtersSlice.reducer;
